module.exports = __webpack_public_path__ + "static/deal-engine-6d6c00e8b5e07d8d101b9985c2d7b802.jpg";